import dayjs from 'dayjs';

export function convertLocalDateTimeToZero(date: dayjs.Dayjs) {
  const dayjsDate = dayjs(date);

  const year = dayjsDate.year();
  const month = dayjsDate.month() + 1;
  const day = dayjsDate.date();

  return `${year}-${month < 10 ? '0' + month : month}-${
    day < 10 ? '0' + day : day
  }T00:00:00.000Z`;
}
